import React, { Component } from 'react';

import styles from './cmsDevicePanel.module.scss';
import CmsDevices from './CmsDevices';
import { withDevices } from '../../../shared/containers/containerDevices';
import TooltipWrapper from '../../../shared/items/contols/tooltipWrapper';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CmsConnectedSensors from './CmsConnectedSensors';
import { withCurrentDevices } from '../../../shared/containers/containerCurrentDevice';
import { withAuth } from '../../../shared/containers/containerAuth';
import CmsDeviceDataTools from './CmsDeviceDataTools';
import CmsDeviceComands from './CmsDeviceComands/CmsDeviceComands';

class CmsDevicePanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabIndex: 0,
      error: null,
    };
  }

  componentDidMount() {
    const { onClearDevices, onGetDevice, deviceId } = this.props;
    onGetDevice(deviceId);
    onClearDevices();
  }

  componentWillUnmount() {
    const { onClearCurrentDevice } = this.props;

    onClearCurrentDevice();
  }

  selectTab(tabIndex) {
    this.setState({ tabIndex });
  }

  getTabs() {
    const { tabIndex } = this.state;
    const titles = ['Информация', 'Датчики', 'Замена устройства', 'Команды'];

    return titles.map((item, index) => {
      return (
        <div
          key={index}
          className={tabIndex === index ? styles.cmsTabActive : styles.cmsTab}
          onClick={this.selectTab.bind(this, index)}
        >
          {item}
        </div>
      );
    });
  }

  errorHandle(e) {
    this.setState({
      error: e,
    });
  }

  viewTab() {
    const { tabIndex } = this.state;
    switch (tabIndex) {
      case 1:
        return <CmsConnectedSensors />;
      case 2:
        return <CmsDevices devicePanelEnable={false} isTransering={true} />;
      case 3:
        return <CmsDeviceComands />;

      default:
        return (
          <CmsDeviceDataTools onErrorHandle={this.errorHandle.bind(this)} />
        );
    }
  }

  getType(value) {
    const { protocolMarkers } = this.props;

    if (protocolMarkers === null) {
      return null;
    }

    return protocolMarkers.protocolMarkers.filter(
      (protocol) => protocol.value === value,
    )[0].title;
  }

  render() {
    const { onViewDevicePanel, currentDevice } = this.props;

    const { error } = this.state;

    return (
      <div className={styles.devicepanelContainer}>
        <div>
          <div style={{ display: 'flex' }}>
            {currentDevice !== null ? (
              <div>
                <h2>
                  {'Устройство '}
                  {currentDevice.imei} {this.getType(currentDevice.type)}
                  <div style={{ color: 'red' }}>{error}</div>
                </h2>
              </div>
            ) : null}
            <div className={styles.cmsClose}>
              <TooltipWrapper title={'Закрыть'} position="top">
                <div
                  onClick={() => {
                    onViewDevicePanel();
                  }}
                >
                  <HighlightOffIcon />
                </div>
              </TooltipWrapper>
            </div>
          </div>
        </div>

        <div className={styles.cmsDeviceTabsContainer}>{this.getTabs()}</div>
        <div>{this.viewTab()}</div>
      </div>
    );
  }
}

export default withAuth(withCurrentDevices(withDevices(CmsDevicePanel)));
